import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { FiCalendar, FiUser, FiShare2 } from "react-icons/fi";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Navbar/navbarTwo";

interface Berita {
  id: number;
  judul: string;
  kategori: string;
  kategori_web: string;
  gambar: string;
  deskripsi: string;
  created_at: string;
  user?: {
    name: string;
  };
}

const NewsDetailPage = () => {
  const { id } = useParams();
  const [news, setNews] = useState<Berita | null>(null);
  const [others, setOthers] = useState<Berita[]>([]);
  const [loading, setLoading] = useState(true);
  const IconCalender = FiCalendar as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconUser = FiUser as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconShare = FiShare2 as React.FC<React.SVGProps<SVGSVGElement>>;
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const API = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    Promise.all([fetch(`${API}/api/berita/${id}`).then((res) => res.json()), fetch(`${API}/api/berita?per_page=10`).then((res) => res.json())])
      .then(([detailRes, listRes]) => {
        setNews(detailRes.data);
        setOthers(listRes.data || []);
      })
      .finally(() => setLoading(false));
  }, [API, id]);

  const formatDate = (date: string) =>
    new Date(date).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

  if (loading) {
    return <div className="text-center py-20 text-gray-400">Memuat berita...</div>;
  }

  if (!news) {
    return <div className="text-center py-20 text-red-500">Berita tidak ditemukan</div>;
  }

  return (
    <>
      <section className="bg-white text-gray-300 py-10 font-montserrat">
        <div className="fixed top-0 left-0 w-full z-40 bg-white">
          <Navbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        </div>
        <div className="max-w-[1200px] mx-auto px-4 lg:px-6 grid grid-cols-1 lg:grid-cols-12 gap-10 mt-24">
          {/* ================= CONTENT ================= */}
          <article className="lg:col-span-8">
            {/* CATEGORY */}
            <span className="inline-block mb-4 bg-red-500/20 text-red-600 px-3 py-1 rounded-md text-sm font-medium">{news.kategori_web}</span>

            {/* TITLE */}
            <h1 className="text-[#131010] text-2xl md:text-3xl lg:text-4xl font-bold leading-tight mb-4">{news.judul}</h1>

            {/* META */}
            <div className="flex flex-wrap items-center gap-4 text-sm text-gray-500 mb-6">
              <div className="flex items-center gap-1">
                <IconUser />
                {news.user?.name || "Admin"}
              </div>
              <div className="flex items-center gap-1">
                <IconCalender />
                {formatDate(news.created_at)}
              </div>
              <button onClick={() => navigator.clipboard.writeText(window.location.href)} className="flex items-center gap-1 hover:text-red-600 transition">
                <IconShare />
                Salin URL
              </button>
            </div>

            {/* IMAGE */}
            <div className="mb-8 rounded-xl overflow-hidden border">
              <img src={news.gambar} alt={news.judul} className="w-full max-h-[420px] object-cover" />
            </div>

            {/* CONTENT */}
            <div className="prose prose-invert max-w-none text-gray-600 prose-p:leading-relaxed" dangerouslySetInnerHTML={{ __html: news.deskripsi }} />
          </article>

          {/* ================= SIDEBAR ================= */}
          <aside className="lg:col-span-4">
            <h3 className="text-[#131010] text-lg font-semibold mb-5 border-b border-gray-700 pb-2">Berita Lainnya</h3>

            <div className="space-y-5">
              {others
                .filter((item) => item.id !== news.id)
                .map((item) => (
                  <Link to={`/news/detail/${item.id}`} key={item.id} className="flex gap-4 group">
                    <img src={item.gambar} alt={item.judul} className="w-24 h-20 object-cover rounded-lg flex-shrink-0" />

                    <div>
                      <h4 className="text-[#131010] text-sm font-medium line-clamp-2 group-hover:text-red-600 transition">{item.judul}</h4>
                      <p className="text-xs text-gray-500 mt-1">{formatDate(item.created_at)}</p>
                    </div>
                  </Link>
                ))}
            </div>
          </aside>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default NewsDetailPage;
